// --- Our Modules --------------------------------------------------------------------------------
import constants from "@/config/constants";
import useAuth from "@/hooks/useAuth";
// --- Logic --------------------------------------------------------------------------------------
/**
 * There are no admin roles and no permission arrays. An admin reaches every segment except the ones
 * marked super-only — which mirrors the backend's `ADMIN_SUPER_MODELS` — and `isSuper` reaches all of
 * them.
 *
 * Hiding a section is not security. The API refuses it too.
 */
export default function usePermission() {
    const admin = useAuth((state) => state.admin);
    const isSuper = !!admin?.isSuper;

    const canAccess = (model: string): boolean => {
        if (!admin) return false;
        if (isSuper) return true;
        return !constants.superModels.includes(model);
    };

    return { admin, isSuper, canAccess };
}
